module.exports = __webpack_public_path__ + "static/media/person.37adc065.svg";